import React from 'react';
import { Theme, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    height: '100%',
    backgroundColor: theme.palette.background.default
  }
}));

interface ContentRootProps {
}

const ContentRoot: React.FC<ContentRootProps> = ({ children }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      { children }
    </div>
  );
};

export default ContentRoot;
